import { makeSelector } from 'containers/app/selectors'

const activeDrawer = (state) => state.getIn(['drawer', 'active'])
const innerActiveDrawer = (state) => state.getIn(['drawer', 'innerActive'])

export const getActiveDrawer = makeSelector(activeDrawer)
export const getInnerActiveDrawer = makeSelector(innerActiveDrawer)
